import React from 'react';
import { 
    EditButton,
    List, 
    Datagrid,
    TextField, 
    TopToolbar,
    DateField,
    CardActions,
    ListButton,
    Show,
    SimpleShowLayout,
    BooleanField,
    ArrayInput,
    SimpleFormIterator
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from  '../../controls/LinkToCreate';
import moment from 'moment';
import ErrorBoundary from '../../ErrorBoundary';

const useStyles = makeStyles({

    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float:    'left', 
        marginRight: '1rem' 
    },
    hidden : {
        display: 'none' 
    },
    inputStyle : {
        width :'20px',
    },
    controlInputStyle : {
       width :'70px',
       fontSize: '8'
   },
    labelStyle : {
       width :'40px',
       backgroundColor: 'silver'
   },
   iniLabelStyle : {
       width :'20px',
       backgroundColor: 'silver'
   },
   dateStyle : {
       width: '120px',
       
   },
   tableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'1px solid  black', 
       width: "100%"
   },
   h3: {
       textAlign: 'center',
       width: '100%'
   },
   clearTableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'0px solid  black', 
       width: "100%"
   },
   inlineBlock: {
       display: 'inline-flex',
       margin: '5px',
       padding: '5px',
   },

});


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CalActions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate id={props.filterValues.ins_id}  name='Create' path='/val_REFRA_METR_o/create' serial_num={props.filterValues.serial_num}/>
        <ListButton basePath={'/valinstrument'} label="Validation List" />
    </CardActions>
);


const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.is_qa > 0 ? '' : <EditButton  record={record} label='Update'/> ;
}

const ShowDetails = ({...props}) => {
    const classes = useStyles();
    var readings = [];

    //console.log(props.record)
    if(props && props.record && props.record.readings){
        try{
          readings =JSON.parse(props.record.readings) 
        } catch(e) {
          readings = props.record.readings;
        };
    }

    return(
            <table className={classes.tableStyle} >
            <tbody  > 
                <tr>
                    <td>
                    <table className={classes.clearTableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan={4} ><center><h3>REFRACTOMETER</h3></center></td>
                            </tr>
                            <tr>
                                <td>Center Name:</td><td><TextField source='center'  label=''  /></td>
                                <td>Serial Number:</td><td><TextField source='serial_num'  label='' /></td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr >
                <td>
                    <table className={classes.tableStyle} >
                    <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>REFRACTOMETER</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextField source='center'  label=''/></td>
                        <td>Instrument Serial Number:</td><td><TextField source='serial_num'  label=''  /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <p><b><u>Installation Qualification (IQ):</u></b></p>
                        Set up Reichert TS Meter-DSP per User’s Guide
                        <p><b><u>Operational Qualification:</u></b></p>
                         Room Temperature Thermometer
                        <p><b>Criteria:  Must be within acceptable temperature range, room temperature (10◦C to 45◦C).  Attach NIST certificate with of thermometer used during validation.</b></p>
                        </td>
                    </tr>
                    <tr>
                        <td>Serial Number:</td><td><TextField source="sub_serial_num" label=""   /></td>
                        <td>MIN Temperature:</td><td><TextField source="min_temp" label=""   /></td>
                    </tr>
                    <tr>
                        <td>Actual Temperature:</td><td><TextField source="act_temp" label=""   /></td>
                        <td>MAX Temperature:</td><td><TextField source="max_temp" label=""   /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <b><u>Quality Control Test</u></b>
                        <p><b>Criteria:  New vials must be opened the day the Operational Qualification is performed, SOP 09.25, 
                            REFRACTOMETER DAILY CALIBRATION and manufacturer’s instructions must be followed.  
                            Manufacture’s expiration date must be used and the manufacture’s assay sheet attached</b></p>
                           
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Assure H2O reading is within +/-0.1 g/100 ml at room temperature (10◦C to 45◦C).<BooleanField source="is_h2o" label = '' /></td>
                        <td>Initial:<TextField source="h2o_init" label=""   /></td>
                        <td>Date:<DateField source="h2o_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Low Control Lot Number:</td><td><TextField source="low_con" label=""   /></td>
                        <td>Low Control Expiration Date:</td><td><DateField source="low_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Normal Control Lot Number:</td><td><TextField source="nor_con" label=""   /></td>
                        <td>Normal Control Expiration Date:</td><td><DateField source="nor_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>High Control Lot Number:</td><td><TextField source="high_con" label=""   /></td>
                        <td>High Control Expiration Date:</td><td><DateField source="high_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Low Control Result:</td><td><TextField source="low_con_rst" label=""   /></td>
                        <td>Normal Control Result:</td><td><TextField source="nor_con_rst" label=""   /></td>
                    </tr>
                    <tr>
                        <td>High Control Result:</td><td><TextField source="high_con_rst" label=""   /></td>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Low Control Result within acceptable manufacturer’s ranges?<BooleanField source='low_con_acpt' label='' /></td>
                        <td>Initial: <TextField source='low_con_acpt_init' label='' /></td>
                        <td>Date: <DateField source='low_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Normal Control Result within acceptable manufacturer’s ranges?<BooleanField source='nor_con_acpt' label='' /></td>
                        <td>Initial: <TextField source='nor_con_acpt_init' label='' /></td>
                        <td>Date: <DateField source='nor_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>High Control Result within acceptable manufacturer’s ranges?<BooleanField source='high_con_acpt' label='' /></td>
                        <td>Initial: <TextField source='high_con_acpt_init' label='' /></td>
                        <td>Date: <DateField source='high_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <p><b><u>Performance Qualification:</u></b></p>
                        <b>Criteria:  Must be within manufacturer’s assay sheet specifications (attached) and within .2 values of each other 
                            for each level of control being tested.  
                            Three different trained employees must perform the quality control at each level 3 different times.</b>
                        </td>
                    </tr>
                    <tr>
                        <td>Low Control Lot Number:</td><td><TextField source="low_con_p" label=""   /></td>
                        <td>Low Control Expiration Date:</td><td><DateField source="low_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Normal Control Lot Number:</td><td><TextField source="nor_con_p" label=""   /></td>
                        <td>Normal Control Expiration Date:</td><td><DateField source="nor_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>High Control Lot Number:</td><td><TextField source="high_con_p" label=""   /></td>
                        <td>High Control Expiration Date:</td><td><DateField source="high_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Entered By Initial: <TextField source='enterd_by_init' label='' /></td>
                        <td>Date: <DateField source='enterd_by_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr><td colSpan={4}>&nbsp;</td></tr>
                    <tr>
                        <td colSpan={4}>
                            <table className={classes.tableStyle} >
                                <tbody>
                                <tr>
                                    <td className={classes.labelStyle}>#</td>
                                    <td className={classes.labelStyle}>Low Control</td>
                                    <td className={classes.labelStyle}>Initial</td>
                                    <td className={classes.labelStyle}>Date</td>
                                    <td className={classes.labelStyle}>Normal control</td>
                                    <td className={classes.labelStyle}>Initial</td>
                                    <td className={classes.labelStyle}>Date</td>
                                    <td className={classes.labelStyle}>High control</td>
                                    <td className={classes.labelStyle}>Inital</td>
                                    <td className={classes.labelStyle}>Date</td>
                                </tr>
                                {
                                    readings && readings.map((item, index) =>(
                                        <tr>
                                        <td>{index}</td>
                                        <td>{item['low_con']}</td>
                                        <td>{item['low_init']}</td>
                                        <td>{item['low_dt']}</td>
                                        <td>{item['nor_con']}</td>
                                        <td>{item['nor_init']}</td>
                                        <td>{item['low_dt']}</td>
                                        <td>{item['high_con']}</td>
                                        <td>{item['high_init']}</td>
                                        <td>{item['low_dt']}</td>
                                    </tr>
                                    )
                                )}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr><td colSpan={4}>&nbsp;</td></tr>
                    <tr>
                        <td colSpan={4}>All low level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanField source='is_low_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>All normal level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanField source='is_nor_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>All high level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanField source='is_high_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td>Results Evaluated By Initial</td><td><TextField source='eval_init' label=''/></td>
                        <td>Date</td><td><TextField source='eval_dt' label=''/></td>
                    </tr>
                    <tr>
                        <td colSpan={4}><b>Summary:</b></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Equipment meets validation criteria and manufacturer’s specifications and is acceptable for use
                        <BooleanField source='is_equip_val'  label='' /></td>
                        <td>Inital<TextField source='equip_val_init'  label=''/></td>
                        <td>Date<DateField source='equip_val_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Equipment DOES NOT meet validation criteria and manufacturer’s specifications and is NOT acceptable for use
                        <BooleanField source='is_equip_not_val'  label='' /></td>
                        <td>Inital<TextField source='equip_not_val_init'  label=''/></td>
                        <td>Date<DateField source='equip_val_not_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <tr>
                        <td  colSpan={4}>
                            <table  className={classes.tableStyle} >
                            <tr>
                                <td>Center Manager:</td><td><TextField source='mgr_name' label='Name' /></td>
                                <td>Initial</td><td><TextField source='mgr_sign' label='' /></td>
                                <td>Date</td><td><DateField source='mgr_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Quality Assurance:</td><td><TextField source='qa_name' label='Name' /></td>
                                <td>Initial</td><td><TextField source='qa_sign' label='' /></td>
                                <td>Date</td><td><DateField source='qa_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Laboratory Director:</td><td><TextField source='dir_name' label='Name' /></td>
                                <td>Initial</td><td><TextField source='dir_sign' label='' /></td>
                                <td>Date</td><td><DateField source='dir_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Corporate Quality:</td><td><TextField source='qa_name' label='Name' /></td>
                                <td>Initial</td><td><TextField source='qa_sign' label='' /></td>
                                <td>Date</td><td><DateField source='qa_dt' label='' /></td>
                            </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>
    )
}

const PostShowActions = () => (
    <TopToolbar>
        <></>
    </TopToolbar>
);

const View= props =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
        actions={<PostShowActions />}
    >
        <SimpleShowLayout   >
            <ShowDetails  />    
        </SimpleShowLayout>
    </Show>
);

const TechInitDate= ({record})=>(
    record && record.tech_date ? 
   <>
    {record.tech_init + ' on ' + moment(record.tech_date).format('MM/DD/YYYY')}
   </> : <>{record.tech_init}</>
)

const QAInitDate= ({record})=>(
    record && record.qa_date ? 
   <>
    {record.qa_init + ' on ' + moment(record.qa_date).format('MM/DD/YYYY')}
   </> : <>{record.qa_init}</>
)

export const InsList = ({...props }) => (
<ErrorBoundary>  
    <List 
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<CalActions/>} 
        title ="Validation | REFRACTOMETER | Other"
        >
        <Datagrid  expand={<View  {...props}  />} >
            <TextField source="serial_num" label="Serial Number" />
            <TextField source="center" label="Center" />
            <Editable />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default InsList;
